import { DialogContent, Stack } from "@mui/material"
import { DialogActions, DialogHandler, DialogTitle, TextField, Typography } from "@cakemail-org/ui-components-v2"
import { t } from "i18next"
import { ChangeEvent, KeyboardEvent, KeyboardEventHandler, MouseEvent, useLayoutEffect, useRef, useState } from "react"
import "./styles.scss"
import { TDeleteDialogContent } from "../deleteDialog/types"
import { TRenameDialogContent, TShowRenameDialog, TShowRenameDialogPromise } from "./types"


export async function showRenameDialog({ initName, resourceKey }: TShowRenameDialog): Promise<TShowRenameDialogPromise> {
    return new Promise((resolve, reject) => {
        DialogHandler.show({
            content: <RenameDialogContent resolve={resolve} reject={reject} initName={initName} resourceKey={resourceKey} />,
            managedByContent: true
        })
    })
}

function RenameDialogContent({ resolve, reject, initName, resourceKey }: TRenameDialogContent) {
    const [value, setValue] = useState<string>(initName || "")

    useLayoutEffect(() => {
        const dialogInput = document.querySelectorAll(".renameDialog input")[0] as HTMLInputElement
        dialogInput.focus()
    }, [])

    function handleChange(event: ChangeEvent<HTMLInputElement>) {
        const { value } = event.currentTarget
        setValue(value)
    }

    function handleKeyDown(event: KeyboardEvent<HTMLInputElement>) {
        if (event.key === "Enter") {
            const confirmButton = document.querySelector('.renameDialog button:last-child') as HTMLButtonElement
            confirmButton.click()
        }
    }

    function handleConfirm(event: MouseEvent<HTMLButtonElement>, btnRef: any) {
        resolve({ btnRef, value })
    }
    function handleCancel() {
        DialogHandler.hide()
        reject()
    }
    return <Stack className="renameDialog">
        <DialogTitle variant="h2">
            {t("rename-dialog-heading-txt", { resource: t(resourceKey) })}</DialogTitle>
        <DialogContent sx={{ marginTop: 8 }}>
            <TextField
                label={t("general-name")}
                onChange={handleChange}
                value={value}
                onKeyDown={handleKeyDown}
            />
        </DialogContent>
        <DialogActions
            primaryBtnText={t("general-save")}
            primaryBtnOnClick={handleConfirm}
            primaryBtnDisabled={value === ""}
            secondaryBtnText={t("general-cancel")}
            secondaryBtnOnClick={handleCancel}
        />
    </Stack >
}